<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Lithium_Field_Url')"
        prop="params.url"
        :hint="$t('Integrations_Lithium_Field_Url_Hint')"
      >
        <el-input v-model="model.params.url" placeholder="https://" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_Domain')"
        prop="params.domain"
        :hint="$t('Integrations_Lithium_Field_Domain_Hint')"
      >
        <el-input v-model="model.params.domain" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_ClientUsername')"
        prop="params.client_username"
        :hint="$t('Integrations_Lithium_Field_ClientUsername_Hint')"
      >
        <el-input v-model="model.params.client_username" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_ClientPassword')"
        prop="params.client_password"
        :hint="$t('Integrations_Lithium_Field_ClientPassword_Hint')"
      >
        <el-input v-model="model.params.client_password" show-password />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_LoginUsername')"
        prop="params.login_username"
        :hint="$t('Integrations_Lithium_Field_LoginUsername_Hint')"
      >
        <el-input v-model="model.params.login_username" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_LoginPassword')"
        prop="params.login_password"
        :hint="$t('Integrations_Lithium_Field_LoginPassword_Hint')"
      >
        <el-input v-model="model.params.login_password" show-password />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Lithium_Field_EncryptionKey')"
        prop="params.encryption_key"
        :hint="$t('Integrations_Lithium_Field_EncryptionKey')"
      >
        <el-input v-model="model.params.encryption_key" />
      </rest-form-item>
      <rest-form-item
        prop="params.enable_promotions"
        :hint="$t('Integrations_Lithium_Field_Enable_Promotions_Hint')"
      >
        <el-switch
          v-model="switchValue"
          @change="promotionStatus"
          :active-text="$t('Integrations_Lithium_Field_Enable_Promotions')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import Integrations from '@/modules/integrations/types'

export default {
  name: 'LithiumSettings',
  components: {
    FormSection,
    RestFormItem
  },

  mounted() {
    if (
      this.$route.name !== 'IntegrationCreate' &&
      this.model.params.enable_promotions === undefined
    ) {
      this.model.params.enable_promotions = 1
      this.switchValue = 1
    }
    this.switchValue = this.model.params.enable_promotions
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          url: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          domain: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          client_username: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          client_password: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          login_username: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          login_password: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          encryption_key: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      },
      switchValue: 0
    }
  },

  methods: {
    promotionStatus() {
      this.model.params.enable_promotions = this.switchValue
      let action = Integrations[this.model.type].actions.filter(
        action => action.label === 'Integrations_Lithium_Action_Sync'
      )[0]
      action.disabled = !this.switchValue
    }
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/lithium/LithiumSettings.vue